import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../../components/SectionHeader'

const LibPostsWrapper = styled.div`
    display: block;
`

const PostsFlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`

const settings = {
    dots: true,
    slidesToScroll: 1,
    centerMode: false,
    infinite: false,
    padding: 300,
    slidesToShow: 5,
    speed: 500,
    arrows: false,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1563,
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
}

const RelatedPostsSlickSlider = ({ children }) => {
    const { t } = useTranslation()

    return (
        <Box pos={'relative'} mb={24}>
            <SectionHeader title={t('titles.posts')} subtitle={t('subtitles.posts')} />
            <Box py={[4]} px={[2, 2, 4, 8, 12]}>
                {children.length > 6 && (
                    <LibPostsWrapper>
                        <Slider {...settings}>{children}</Slider>
                    </LibPostsWrapper>
                )}

                {children.length <= 6 && <PostsFlexWrapper>{children}</PostsFlexWrapper>}
            </Box>
        </Box>
    )
}

export default RelatedPostsSlickSlider
